<template>
  <div class="tw-container tw-bg-gray-100 tw-mx-auto tw-w-full tw-h-full tw-rounded-b-md">
    <div class="tw-relative tw-wrap tw-overflow-hidden tw-p-4 tw-h-full">
      <div class="tw-border-2-2 tw-absolute tw-border-opacity-20 tw-border-gray-700 tw-h-full tw-border line-placement"></div>
      <div v-if="isLoading === false">
        <div v-for="item in items" :key="item.id">
          <timeline-card :title="item.title" :subheading="item.subheading" :textValue="item.textValue" :orientation="item.orientation" :iconName="item.iconName" />
        </div>
      </div>
      <div v-else>
        <timeline-card :isLoading="true" orientation="left" />
        <timeline-card :isLoading="true" orientation="right" />
        <timeline-card :isLoading="true" orientation="left" />
        <timeline-card :isLoading="true" orientation="left" />
      </div>
    </div>
  </div>
</template>
<script>
import TimelineCard from "@/components/Timeline/TimelineCard";

export default {
  components: { TimelineCard },
  name: "Timeline",
  props: {
    items: Array,
    isLoading: { type: Boolean, default: false },
  },
};
</script>
<style>
.line-placement {
  left: calc(50% - 1px);
}
/* for mobile phones */
@media screen and (max-width: 640px) {
  .line-placement {
    left: 31px;
  }
}
</style>
